import { useEffect, useState } from "react";
import { CustomButton } from "../../../shared/CustomButton";
import { Add } from "@mui/icons-material";
import CustomModal from "../../../shared/CustomModal";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getFn, postFn, putFn } from "../../../Services/sharedGeneralFn";
import { API_URLS } from "../../../config/apiUrls";
import SearchAndSelect from "../../../shared/SearchAndSelect";
import { toast } from "react-toastify";
import CustomInput from "../../../shared/CustomInput2";

const AddNewVariantTypeTwo = ({ editVariantData, setEditVariantData }) => {
  const [open, setOpen] = useState(false);
  const [variantName, setVariantName] = useState("");
  const [selectCategory, setSelectCategory] = useState();
  const query = useQueryClient();

  const handleClose = () => {
    setOpen(false);
    setEditVariantData(null);
    setVariantName("");
    setSelectCategory();
  };

  const { data: typeTwoCategories } = useQuery(
    ["typeTwoCategories"],
    () => getFn({}, API_URLS.storageTypeApi),
    {
      select: (data) =>
        data?.data?.data.map((item) => {
          return {
            label: item.title + " ( " + item.category_name + " ) ",
            value: item.id,
          };
        }) || [],
    }
  );

  const args = [
    {
      variant_value_id: editVariantData?.id || undefined,
      variant_storage: selectCategory,
      value: variantName,
    },
    API_URLS.storageVariantApi,
  ];

  const { mutate: mutation } = useMutation(
    () => (editVariantData ? putFn(...args) : postFn(...args)),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          query.invalidateQueries("storageTypeData");
          handleClose();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );

  const handleSubmit = () => {
    if (variantName.length > 0 && selectCategory) {
      mutation();
    } else {
      if (!selectCategory) {
        toast.warn("Select a category");
      } else {
        toast.warn("Please fill all the details");
      }
    }
  };

  useEffect(() => {
    if (editVariantData) {
      setOpen(true);
      const { variant_storage, value } = editVariantData;
      setVariantName(value);
      setSelectCategory(variant_storage);
    }
  }, [editVariantData]);

  return (
    <div>
      <CustomButton
        className="mx-0 border border-black"
        onClick={() => setOpen(true)}
      >
        <Add /> Add Type Two Value
      </CustomButton>
      <CustomModal
        className="w-1/3"
        open={open}
        onClose={handleClose}
        title={`${editVariantData ? "Update" : "Add New"} Storage Variant`}
      >
        <div className="flex flex-col gap-4">
          <SearchAndSelect
            label="Type Two Category"
            value={selectCategory}
            setValue={setSelectCategory}
            options={typeTwoCategories}
          />
          <CustomInput
            value={variantName}
            label="Value"
            placeholder={`${editVariantData ? "Update" : "Add"} Name`}
            onChange={(e) => setVariantName(e.target.value)}
          />
          <CustomButton
            className="mx-0 ml-auto border border-black w-28"
            variant="outlined"
            onClick={handleSubmit}
          >
            {editVariantData ? "Update" : "Add"}
          </CustomButton>
        </div>
      </CustomModal>
    </div>
  );
};

export default AddNewVariantTypeTwo;
